import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ProtectedRoute = (props) => {
  const { user, isLoading, Component } = props;
  const navigate = useNavigate();

  useEffect(() => {
    if (user === null && isLoading === false) navigate('/');
  });

  return (
    <div>
      <Component />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  isLoading: state.auth.isLoading,
});

export default connect(mapStateToProps)(ProtectedRoute);
